import React from 'react';
import PageLoading from '../../elements/PageLoading';

function TravelInfortuniGuaranteeModal({
  loadingDataset, formData, register,
}) {
  return (
    <div>

      {loadingDataset ? <PageLoading /> : (
        <div>
          <form action="">
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">Beneficiario</label>
              <select
                className="form-select"
                defaultValue=""
                aria-label="Beneficiario"
                {...register('infortuni_data.value')}
              >
                <option disabled value="">Seleziona Beneficiario</option>
                <option value="1">Eredi legittimi o testamentari</option>
                <option value="2">Altra persona</option>
              </select>
            </div>
            {formData.infortuni_data.value === '2' ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput2" className="form-label">Nome e Cognome Beneficiario</label>
                <input type="text" {...register('infortuni_data.beneficario')} className="form-control" placeholder="Nome beneficiario" />
              </div>
            ) : ''}
            <input type="hidden" {...register('infortuni_data.contractor_id')} className="form-control" placeholder="Nome beneficiario" />
            <input type="hidden" {...register('infortuni_data.insured_id')} className="form-control" placeholder="Nome beneficiario" />

          </form>
        </div>
      )}

    </div>
  );
}

export default TravelInfortuniGuaranteeModal;
